import React, { Component } from "react";
import NewsItem from "./NewsItem";
import Spinner from "./Spinner";
import PropTypes from "prop-types";
// import InfiniteScroll from "react-infinite-scroll-component";

export class News extends Component {
  static defaultProps = {
    cntr: "in",
    pgSize: 8,
    cat: "general",
  };
  static propTypes = {
    cntr: PropTypes.string,
    pgSize: PropTypes.number,
    cat: PropTypes.string,
  };
  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  constructor(props) {
    super(props);
    this.state = {
      article: [],
      loading: false,
      page: 1,

      totalResults: 0,
      url: "",
    };
    document.title = `NewsMaster - ${this.capitalizeFirstLetter(
      this.props.cat
    )}`;
  }
  async updateNews() {
    this.props.setProgress(0);
    // let url = `https://newsapi.org/v2/top-headlines?country=${this.props.cntr}&category=${this.props.cat}&apiKey=${this.props.apiKey}&page=${this.state.page}&pageSize=${this.props.pgSize}`;
    // this.setState({
    //   loading: true,
    // });
    // this.props.setProgress(10);
    // let data = await fetch(url);

    this.props.setProgress(50);
    let data = await require("../dummyDB/Data.json");
    let cat = `${this.props.cat}`;
    this.props.setProgress(70);
    this.setState({
      article: data[cat].articles,
      totalResults: data[cat].totalResults,
      loading: false,
    });
    this.props.setProgress(100);
  }
  async componentDidMount() {
    this.updateNews();
  }

  // fetchMoreDataThen = async () => {
  //   let url = `https://newsapi.org/v2/top-headlines?country=${this.props.cntr}&category=${this.props.cat}&apiKey=${this.props.apiKey}&page=${this.state.page}&pageSize=${this.props.pgSize}`;

  //   this.setState({
  //     loading: true,
  //   });
  //   let data = await fetch(url);

  //   this.setState({
  //     article: this.state.article.concat(cat.articles),
  //     totalResults: cat.totalResults,
  //     loading: false,
  //   });
  // };
  // fetchMoreData = async () => {
  //   this.setState({ page: this.state.page + 1 }, () => {
  //     this.fetchMoreDataThen();
  //   });
  // };
  render() {
    // dummy Data
    return (
      <>
        <h2 className="text-center pt-3" style={{ marginTop: "80px" }}>
          NewsMaster - Top {this.capitalizeFirstLetter(this.props.cat)}{" "}
          Headlines
        </h2>
        {this.state.loading && <Spinner />}
        {/* <InfiniteScroll
          dataLength={this.state.article.length}
          next={this.fetchMoreData}
          hasMore={this.state.article.length !== this.state.totalResults}
          loader={<Spinner />}
        > */}
        <div className="container my-4">
          <div className="row">
            {
              // !this.state.loading &&
              this.state.article.map((element) => {
                return (
                  <div className="col-md-4" key={element.title}>
                    <NewsItem
                      title={element.title ? element.title.slice(0, 52) : ""}
                      desc={
                        element.description
                          ? element.description.slice(0, 130)
                          : ""
                      }
                      url={element.urlToImage}
                      newsUrl={element.url}
                      author={element.author}
                      date={element.publishedAt}
                      source={element.source.name}
                    />
                  </div>
                );
              })
            }
          </div>
        </div>
        {/* </InfiniteScroll> */}
      </>
    );
  }
}

export default News;
